import { render, staticRenderFns } from "./p32.vue?vue&type=template&id=7537ab28&scoped=true&"
import script from "./p32.vue?vue&type=script&lang=js&"
export * from "./p32.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537ab28",
  null
  
)

export default component.exports